var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-row",
          [
            _vm.statusView != "C"
              ? _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.addData },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          disabled:
                            _vm.multipleSelection.length > 0 ? false : true,
                          type: "danger",
                        },
                        on: { click: _vm.delData },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.saveData },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "ux-grid",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%", "margin-top": "15px" },
            attrs: { data: _vm.tableData, "tooltip-effect": "dark" },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("ux-table-column", {
              attrs: { align: "center", type: "checkbox", width: "80" },
            }),
            _c("ux-table-column", {
              attrs: { title: "Min类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: scope.row.minType,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "minType", $$v)
                            },
                            expression: "scope.row.minType",
                          },
                        },
                        _vm._l(_vm.minOption, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: { prop: "name", title: "Min" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: scope.row.min,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "min", $$v)
                          },
                          expression: "scope.row.min",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: { prop: "name", title: "Max类型" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: scope.row.maxType,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "maxType", $$v)
                            },
                            expression: "scope.row.maxType",
                          },
                        },
                        _vm._l(_vm.maxOption, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: { prop: "name", title: "Max" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: scope.row.max,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "max", $$v)
                          },
                          expression: "scope.row.max",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: { prop: "name", title: "等级" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: scope.row.grade,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "grade", $$v)
                          },
                          expression: "scope.row.grade",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("ux-table-column", {
              attrs: { prop: "name", title: "排序" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        on: {
                          input: function ($event) {
                            scope.row.orderNo = scope.row.orderNo.replace(
                              /[^\d.]/g,
                              ""
                            )
                          },
                        },
                        model: {
                          value: scope.row.orderNo,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "orderNo", $$v)
                          },
                          expression: "scope.row.orderNo",
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }